module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/district/district.component.html
// module id = ./src/app/Pages/manage/district/district.component.html
// module chunks = main